import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: "app-home-aside-content",
    templateUrl: "./home-aside-content.component.html",
    styleUrls: ["./home-aside-content.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
/**
 * Show BIG aside in homepage and plant
 */
export class HomeAsideContentComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
